import { render, staticRenderFns } from "./edit-application-bank-accounts.vue?vue&type=template&id=29444cfa"
import script from "./edit-application-bank-accounts.vue?vue&type=script&lang=js"
export * from "./edit-application-bank-accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports